import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const BusinessContextForm = ({ formData, onUpdate }) => {
  const businessTypeOptions = [
    { value: 'service', label: 'Service' },
    { value: 'product', label: 'Product' },
    { value: 'hybrid', label: 'Hybrid' }
  ];

  const industryOptions = [
    { value: 'technology', label: 'Technology & Software' },
    { value: 'retail', label: 'Retail & E-commerce' },
    { value: 'healthcare', label: 'Healthcare & Medical' },
    { value: 'finance', label: 'Finance & Banking' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'education', label: 'Education & Training' },
    { value: 'hospitality', label: 'Hospitality & Tourism' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'consulting', label: 'Consulting & Services' },
    { value: 'other', label: 'Other' }
  ];

  const businessModelOptions = [
    { value: 'b2b', label: 'B2B' },
    { value: 'b2c', label: 'B2C' },
    { value: 'both', label: 'Both' }
  ];

  const monthOptions = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const handleMonthToggle = (month) => {
    const currentMonths = formData?.peakMonths || [];
    const updatedMonths = currentMonths?.includes(month)
      ? currentMonths?.filter(m => m !== month)
      : [...currentMonths, month];
    onUpdate({ peakMonths: updatedMonths });
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Business Type"
          placeholder="Select business type"
          options={businessTypeOptions}
          value={formData?.businessType || ''}
          onChange={(value) => onUpdate({ businessType: value })}
          required
        />

        <Input
          label="Years in Operation"
          type="number"
          placeholder="Enter years"
          value={formData?.yearsInOperation || ''}
          onChange={(e) => onUpdate({ yearsInOperation: e?.target?.value })}
          required
        />
      </div>

      <Select
        label="Industry"
        placeholder="Select your industry"
        options={industryOptions}
        value={formData?.industry || ''}
        onChange={(value) => onUpdate({ industry: value })}
        searchable
        required
      />

      <div className="space-y-4">
        <label className="text-sm font-medium text-foreground">
          Is your business seasonal? <span className="text-destructive">*</span>
        </label>
        <div className="flex gap-6">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="isSeasonal"
              value="yes"
              checked={formData?.isSeasonal === 'yes'}
              onChange={(e) => onUpdate({ isSeasonal: e?.target?.value })}
              className="h-4 w-4"
            />
            <span className="text-sm text-foreground">Yes</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="isSeasonal"
              value="no"
              checked={formData?.isSeasonal === 'no'}
              onChange={(e) => onUpdate({ isSeasonal: e?.target?.value, peakMonths: [] })}
              className="h-4 w-4"
            />
            <span className="text-sm text-foreground">No</span>
          </label>
        </div>
      </div>

      {formData?.isSeasonal === 'yes' && (
        <div className="space-y-3 p-4 bg-accent/10 rounded-md border border-accent/20">
          <label className="text-sm font-medium text-foreground">Select Peak Months</label>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {monthOptions?.map((month) => (
              <Checkbox
                key={month}
                label={month}
                checked={formData?.peakMonths?.includes(month)}
                onChange={() => handleMonthToggle(month)}
              />
            ))}
          </div>
        </div>
      )}

      <Input
        label="Primary Revenue Source"
        type="text"
        placeholder="e.g., Consulting services, Product sales"
        value={formData?.primaryRevenueSource || ''}
        onChange={(e) => onUpdate({ primaryRevenueSource: e?.target?.value })}
        required
      />

      <Select
        label="Business Model"
        placeholder="Select business model"
        options={businessModelOptions}
        value={formData?.businessModel || ''}
        onChange={(value) => onUpdate({ businessModel: value })}
        required
      />
    </div>
  );
};

export default BusinessContextForm;